import { IFormSection } from "../../types/common";
import { API_SET_USSD_MERCHANT } from "../../utils/apis";

export const useUSSDMerchantsForm = () => {
  const sections: IFormSection[] = [
    {
      title: "USSD Merchant Details",
      fields: [
        {
          field_name: "merchant_code",
          type: "text",
          label: "Merchant Code",
          description:
            "Enter the unique code assigned to the merchant. This code is used to identify the merchant within the system.",
          props: { required: true },
        },
        {
          field_name: "merchant_number",
          type: "text",
          label: "Merchant Number",
          description:
            "Enter the official merchant number provided during merchant registration. This number must be valid and active.",
          props: { required: true },
        },
        {
          field_name: "access_rule",
          type: "text",
          label: "Access Rule",
          description:
            "Specify the access rule or permission level assigned to this merchant user (for example: admin, operator, or viewer).",
          props: { required: true },
        },
        {
          field_name: "access_number",
          type: "text",
          label: "Access Number",
          description:
            "Enter the mobile phone number associated with the merchant user. This number will be used for contact, authentication, and notifications.",
          props: { required: true },
        },
        {
          field_name: "access_parameter",
          type: "text",
          label: "Access Parameter",
          description:
            "Provide the access parameter required for this rule, such as a reference ID, phone number, or system identifier depending on the selected access rule.",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = "redirect";
  // SUBMIT
  function onSubmit(payload: any, id: string | number) {
    let params = { ...payload };

    return {
      id,
      api: API_SET_USSD_MERCHANT,
      params,
    };
  }

  return { sections, onSubmit, redirect };
};
